<template>
  <div class="thanks_page_container">
    <div id="thanks_page">
        <div class="mountains_icon icon"></div>
        <div class="text">
            <h2>תודה רבה, {{ name }}!</h2>
            <h4>קיבלנו את הפרטים והעברנו אותם לאישור צוות המכרז השקוף</h4>
        </div>
        <p class="details">לאחר אישור ההצטרפות, נקים עבורך פרופיל ונשלח לך מייל עם פרטי ההתחברות למערכת</p>
        <a href="/" class="btn_b text_s" >חזרה לעמוד הבית של המכרז השקוף</a>
    </div>
  </div>
</template>

<script>
export default {
    props: ['name']
}
</script>

<style lang="scss">
.thanks_page_container { flex: 1; display: flex; justify-content: center;
    #thanks_page { display: flex; flex-direction: column; align-items: center; gap: 40px; width: 30%; 
        .mountains_icon {background-image: url(../assets/mountains.svg);  width: 30%; aspect-ratio: 1; height: unset;}
        h2, h4, p {color: var(--dark_blue); font-weight: 400; text-align: center;}
        .text {
            h2 {font-size: var(--h2);}
            h4 {font-size: var(--h4);}
        }
        .details {font-size: var(--h5);}
        .btn_b {}
    }
}
</style>